module.exports = __webpack_public_path__ + "img/escudo-1.456d54fa.svg";